import { Cart } from "../Cart/Cart.js"
const cart = new Cart()
window.cart = cart

import { Auth } from "../Auth/Auth.js"
const auth = new Auth()
window.auth = auth

import { Catalog } from "../Catalog/Catalog.js"
const catalog = new Catalog()
window.catalog = catalog
catalog.applyEvents()

import { Profile } from "../Profile/Profile.js"
const profile = new Profile()
window.profile = profile

$(document).ready(function () {
	function openTab(evt, dataInfo) {
		var tabcontent, tablinks;
		tabcontent = $(".profile-block-info-item");
		tabcontent.css("display", "none");

		tablinks = $(".profile-block-menu-item button");
		tablinks.removeClass("active");

		$("#" + dataInfo).css("display", "block");
		$(evt.currentTarget).addClass("active");
	}

	$('.profile-block-menu-item button').on('click', function (evt) {
		var dataInfo = $(this).data('info');
		openTab(evt, dataInfo);
	});

	$("#defaultOpen").click();
});

$(document).ready(function() {
	var menuBtn = $('.header__burger-btn');
	var menu = $('.header__bottom');
	var body = $('body');
	var btnSms = $('.popup-btn-sms');
	var btnReg = $('.popup-btn-registration');
	var inputTel = $('.popup-input-tel');
	var inputSms = $('.popup-input-sms');
	var btnProf = $('.popup-btn-account');
	var searchBtn1 = $('.header-search__form');
	var searchInp = $('.header-search-input');
	var searchBtn2 = $('.header-search-btn');
  
	menuBtn.click(function() {
		menuBtn.toggleClass('active');
		menu.toggleClass('active');
		body.toggleClass('no-scroll');
	});

	searchBtn1.click(function() {
		searchInp.toggleClass('active');
		searchBtn2.toggleClass('active');
	});

	btnSms.click(function() {
		inputTel.each(function() {
			this.tabIndex = -1;
		});
		inputSms.each(function() {
			this.tabIndex = 0;
		});
		let form = $(this.form);
		
		if (form.is('.reg-form'))
			auth.regPhone(form);
		else if (form.is('.auth-form'))
			auth.resetPass(form);
		
		// body.toggleClass('no-scroll');
	});

	$('.reg-form').submit(function(){
		auth.submitCode($(this));
		return false;
	});
	$('.auth-form').submit(function(){
		auth.ajaxAuth($(this));
		return false;
	});
});

$(document).ready(function() {
	$('#openPopup').click(function() {
	  	$('#popup').fadeIn();
	});
  
	$('#closePopup').click(function() {
	  	$('#popup').fadeOut();
	});
  
	$('#individual').click(function() {
		$('#individual-content').show();
		$('#legal-content').hide();
	});
  
	$('#legal').click(function() {
		$('#legal-content').show();
		$('#individual-content').hide();
	});
	
	$('#closePopupCart').click(function() {
	  	$('#popup-cart').fadeOut();
	});

	$('#closePopupCartLink').click(function() {
	  	$('#popup-cart').fadeOut();
	});	
});

// POPUP

$(document).ready(function() {
	$('#openPopup').click(function() {
		$('#popup').fadeIn();
		$('body').addClass('no-scroll');
		$('.popup-button-list').show();
		$('.popup-main-title').show();
		$('.popup-registration-title').hide();
		$('.popup-autorization-title').hide();
		$('#individual-content').hide();
		$('#legal-content').hide();
		$('#autorization-individual-content').hide();
		$('#autorization-legal-content').hide();
	});

	$('#individual').click(function() {
		$('#individual-content').show();
		$('#legal-content').hide();
		$('.popup-registration-title').show();
		$('.popup-main-title').hide();
		$('.popup-button-list').hide();
	});

	$('#legal').click(function() {
		$('#legal-content').show();
		$('#individual-content').hide();
		$('.popup-registration-title').show();
		$('.popup-main-title').hide();
		$('.popup-button-list').hide();
	});

	$('#autorization-individual-btn').click(function() {
		$('#individual-content').hide();
		$('#legal-content').hide();
		$('.popup-registration-title').hide();
		$('.popup-autorization-title').show();
		$('#autorization-individual-content').show();
		$('.popup-main-title').hide();
		$('.popup-button-list').hide();
	});

	$('#autorization-legal-btn').click(function() {
		$('#individual-content').hide();
		$('#legal-content').hide();
		$('.popup-registration-title').hide();
		$('.popup-autorization-title').show();
		$('#autorization-legal-content').show();
		$('.popup-main-title').hide();
		$('.popup-button-list').hide();
	});

	$('#registration-individual-btn').click(function() {
		$('#individual-content').show();
		$('#legal-content').hide();
		$('.popup-main-title').hide();
		$('.popup-registration-title').show();
		$('.popup-autorization-title').hide();
		$('#autorization-individual-content').hide();
		$('.popup-button-list').hide();
	});

	$('#registration-legal-btn').click(function() {
		$('#individual-content').show();
		$('#legal-content').hide();
		$('.popup-main-title').hide();
		$('.popup-registration-title').show();
		$('.popup-autorization-title').hide();
		$('#autorization-legal-content').hide();
		$('.popup-button-list').hide();
	});

	$('#closePopup, #popup').click(function(e) {
		if (e.target === this) {
			$('#popup').fadeOut();
			$('body').removeClass('no-scroll');
		}
  	});
});

$(document).ready(function() {
	$('#add-organization').click(function() {
		$('#organization-popup').fadeIn();
		$('body').addClass('no-scroll');
		// $('#organization-popup').show();
	});

	$('#closePopup, #organization-popup').click(function(e) {
		if (e.target === this) {
			$('#organization-popup').fadeOut();
			$('body').removeClass('no-scroll');
			// $('#organization-popup').hide();
		}
  	});
});

$(document).ready(function() {
	$('#add-cart').click(function() {
		$('#popup-cart').fadeIn();
		$('body').addClass('no-scroll');
		// $('#organization-popup').show();
	});

	$('#closePopup, #popup-cart').click(function(e) {
		if (e.target === this) {
			$('#popup-cart').fadeOut();
			$('body').removeClass('no-scroll');
			// $('#organization-popup').hide();
		}
  	});
});

//COOOKIE//
$(document).ready(function() {
	// Проверяем, было ли ранее дано согласие
	if (getCookie("cookie_consent") === "true") {
		hideCookieConsent();
	}

	// Обработчик события клика на кнопку "Принять"
	$("#accept-cookies").click(function() {
		// Сохраняем согласие пользователя в cookie на 365 дней
		document.cookie = "cookie_consent=true; expires=" + new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000).toUTCString() + "; path=/";
		hideCookieConsent();
	});
});

// Функция для скрытия блока с соглашением
function hideCookieConsent() {
	$("#cookie-consent").hide();
}

function setCookie(name, value, expires, path = '/', domain = '', secure = false) {
	expires instanceof Date ? expires = expires.toGMTString() : typeof (expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)], s, i;
	for (i in s = { expires: expires, path: path, domain: domain }) {
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
}

// Функция для получения значения cookie
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return undefined;
}
//COOKIE//

// SCROLL TO BLOCK
// $(function(){
// 	$('.catalog-categories-details-item-link').on('click', function(e){
// 	  	$('html,body').stop().animate({ scrollTop: $('#goods-list').offset().top }, 1000);
// 	  	e.preventDefault();
// 	});
// });

function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
}

let uid = getCookie('seen_item');
if (uid === undefined) {
	setCookie('seen_item', guid(), { expires: 30 });
} else {
	console.log(uid);
}

document.addEventListener("DOMContentLoaded", function () {
	// Функция для замены логотипа
	function updateLogo(selector) {
		document.querySelectorAll(selector).forEach(logoContainer => {
			const source = logoContainer.querySelector("source");
			const img = logoContainer.querySelector("img");
			if (!source || !img) return;

			// Даты для смены логотипа
			const now = new Date();
			const month = now.getMonth() + 1; // getMonth() от 0 до 11
			const day = now.getDate();

			// Логотипы по умолчанию
			let logoWebP = "/media/header-logo.webp";
			let logoPng = "/media/header-logo.png";

			if ((month === 12 && day >= 28) || (month === 1 && day <= 9)) {
				// Новый год (28.12 - 09.01)
				logoWebP = "/media/logo-ny.webp";
				logoPng = "/media/logo-ny.png";
			} else if (month === 2 && day >= 21 && day <= 25) {
				// 23 февраля (21.02 - 25.02)
				logoWebP = "/media/header-logo-23.webp";
				logoPng = "/media/header-logo-23.png";
			}  else if (month === 3 && day >= 3 && day <= 10) {
				// 8 марта (5.03 - 10.03)
				logoWebP = "/media/logo-8.webp";
				logoPng = "/media/logo-8.png";
			} else if (month === 4 && day >= 29 || (month === 5 && day <= 6)) {
				// Майские праздники (29.04 - 06.05)
				logoWebP = "/media/logo-may.webp";
				logoPng = "/media/logo-may.png";
			} else if (month === 5 && day >= 6 && day <= 10) {
				// 9 мая (06.05 - 10.05)
				logoWebP = "/media/logo-9.webp";
				logoPng = "/media/logo-9.png";
			}

			// Меняем srcset и src
			source.setAttribute("srcset", logoWebP);
			img.setAttribute("src", logoPng);
		});
	}

	// Меняем логотипы в хедере и всех футерах
	updateLogo("a.header-logo picture");
	updateLogo("a.footer-block-teaser-logo picture");
});

document.querySelectorAll('.count .minus').forEach(item => {
	item.addEventListener('click', function () {
		--item.parentElement.querySelector('input').value;
		if (item.parentElement.querySelector('input').value < 2) 
		{
			item.parentElement.querySelector('input').value = 1;
			item.classList.add('min');
		}
		$(item.parentElement.querySelector('input')).trigger('change');
	});
});

document.querySelectorAll('.count .plus').forEach(item => {
	item.addEventListener('click', function () {
		++item.parentElement.querySelector('input').value;
		if (item.parentElement.querySelector('input').value > 1) 
		{
			item.parentElement.querySelector('.minus').classList.remove('min');
		}
		$(item.parentElement.querySelector('input')).trigger('change');
	});
});

document.addEventListener('DOMContentLoaded', () => {
    ymaps.ready(initMap);

    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    function initMap() {
        const map = new ymaps.Map('map', {
            center: [43.6028, 39.7341], // Центр карты
            zoom: 12,
            controls: ['zoomControl', 'typeSelector']
        });

        const markers = [
            { id: 'truda37', coords: [43.637735, 39.745178], name: 'ул. Труда 37' },
            { id: 'prig6_2', coords: [43.606336, 39.739874], name: 'ул. Пригородная 6/2' },
            { id: 'truda25a', coords: [43.639328, 39.746042], name: 'ул. Труда 25А' },
            { id: 'loo_razina17', coords: [43.706929, 39.586850], name: 'п. Лоо, ул. Разина 17' },
            { id: 'golovinka_kommunarov1b', coords: [43.797372, 39.463614], name: 'п. Головинка, ул. Коммунаров 1Б' }
        ];

        const placemarks = {};

        // Создаем метки и добавляем их на карту
        markers.forEach(marker => {
            const placemark = new ymaps.Placemark(marker.coords, {
                balloonContent: marker.name
            }, {
                preset: 'islands#icon',
                iconColor: '#FF5733'
            });

            placemarks[marker.id] = placemark;
            map.geoObjects.add(placemark);
        });

        // Получаем переданный адрес из URL
        const addressParam = getQueryParam('address');

        if (addressParam && placemarks[addressParam]) {
            activateAddress(addressParam);
        }

        // Навешиваем обработчики кликов на блоки адресов
        document.querySelectorAll('.contacts-block-info-item').forEach(item => {
            item.addEventListener('click', () => {
                const id = item.dataset.id; // Получаем data-id блока
                if (placemarks[id]) {
                    activateAddress(id);
                }
            });
        });

        // Функция активации адреса
        function activateAddress(id) {
            const activePlacemark = placemarks[id];

            // Центрируем карту и открываем балун
            map.setCenter(activePlacemark.geometry.getCoordinates(), 15);
            activePlacemark.balloon.open();

            // Подсвечиваем соответствующий блок
            document.querySelectorAll('.contacts-block-info-item').forEach(el => el.classList.remove('active'));
            const activeBlock = document.querySelector(`.contacts-block-info-item[data-id="${id}"]`);
            if (activeBlock) {
                activeBlock.classList.add('active');
            }
        }
    }
});

$(window).scroll(function() {
	if ($(this).scrollTop() > 50) {
		$('.to-top').addClass('scrolled');
	} else {
		$('.to-top').removeClass('scrolled');
	}
});

$(document).ready(function(){
	//Скрыть PopUp при загрузке страницы    
	PopUpHide();
});
//Функция отображения PopUp
function PopUpShow(){
	$("#popup1").show();
}
//Функция скрытия PopUp
function PopUpHide(){
	$("#popup1").hide();
}


$('#deliver-active').on('click',function(){
	$('.cart-block-formalization-address').addClass('active');
});

$('#deliver-disable').on('click',function(){
	$('.cart-block-formalization-address').removeClass('active');
});

// // Resize
// $(window).on("resize", function () {

// });


// // Scroll
// $(window).on("scroll", function () {

// })


// // Document click
// $(document).on("click", function (e) {

// });


// // popups
// $(".popup__close, .popup__cancel").on("click", function (e) {
// 	$("body").removeClass("no-scroll");
// 	$(this).closest(".popup").removeClass("active");
// });

// $(".popup").on("click", function (e) {
// 	var callbackPopup = $(".popup__card")
// 	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
// 		$(this).removeClass("active");
// 		$("body").removeClass("no-scroll");
// 	};
// });

// $("[data-popup-open]").on("click", function (e) {
// 	e.preventDefault();
// 	let dataPopupName = $(this).attr("data-popup-open");
// 	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
// 	$("body").addClass("no-scroll");
// 	popup.addClass("active");
// });